import { Stack } from "expo-router";
import React from "react";

export default function MyAnchorsLayout() {
  return (
    <Stack screenOptions={{ headerShown: false }}>
      <Stack.Screen name="index" options={{ title: "My Anchors" }} />
      <Stack.Screen name="[id]" options={{ title: "Anchor Details" }} />
      <Stack.Screen name="new" options={{ title: "Add Anchor" }} />
    </Stack>
  );
}
